import * as table from './TableData';
import {
    CurrentTime,
    GET_COMPANY_FROM_URL,
    currentDate_dmy,
    date_dmy_func,
} from "../../../../components/Common/CommonFunction";

// ⭐ identical coordinates to Scheme's pageBorder — portrait A4
export const pageBorder = (doc) => {
    doc.setDrawColor(0, 0, 0);
    doc.line(570, 16, 30, 16);
    doc.line(30, 815, 30, 16);
    doc.line(570, 815, 570, 16);
    doc.line(570, 815, 30, 815);
};

// ⭐ identical layout to Scheme's pageHeder — logo + centered title
export const pageHeder = (doc) => {
    const companyCode = GET_COMPANY_FROM_URL();
    let storedTheme = null;
    try {
        storedTheme = JSON.parse(localStorage.getItem(`${companyCode}_companyTheme`));
    } catch (e) { }
    const logo = localStorage.getItem(`${companyCode}_CompanyLogo`);

    let logoToUse = null;
    if (!companyCode || companyCode === "Default") {
        logoToUse = logo;
    } else if (storedTheme?.CompanyLogo) {
        logoToUse = logo;
    }
    if (logoToUse) {
        doc.addImage(logoToUse, 'PNG', 33, 17, 60, 38, null, 'FAST');
    }

    doc.addFont("Arial", 'Normal');
    doc.setFont('Arial');
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('WASTAGE REPORT', 250, 40, { align: 'center' });
    doc.setFont(undefined, 'normal');
};

// ⭐ identical boxed date panel to Scheme's reportHeder3, driven by the
// filter dates passed in (from WastageReportDateRange), not row data
export const reportHeder1 = (doc, dateRange = {}) => {
    doc.setFont('Tahoma');
    doc.setFontSize(9);
    doc.setDrawColor(0, 0, 0);
    doc.line(570, 38, 408, 38);
    doc.line(408, 65, 408, 16);

    doc.setFont(undefined, 'bold');
    doc.setFontSize(8);
    doc.text(`From Date: ${dateRange.fromDate ? date_dmy_func(dateRange.fromDate) : "-"}`, 415, 27);
    doc.text(`To Date: ${dateRange.toDate ? date_dmy_func(dateRange.toDate) : "-"}`, 415, 52);
    doc.setFont(undefined, 'normal');

    doc.line(570, 63, 30, 63);
};

export const tableBody = (doc, data, dateRange = {}) => {
    const options = {
        didParseCell: (data1) => {
            const rowType = data1.row.raw[10]; // marker column
            if (rowType === "grandtotal") {
                data1.row.cells[0].colSpan = 5; // spans Wastage No..Batch No (blank cells)
                data1.row.cells[0].styles.halign = "right";
                data1.row.cells[0].styles.fontStyle = "bold";
                data1.row.cells[0].styles.fontSize = 8;
                data1.row.cells[0].styles.fillColor = [211, 211, 211];
                [5, 6, 7, 8, 9].forEach((k) => {
                    data1.row.cells[k].styles.fontStyle = "bold";
                    data1.row.cells[k].styles.fillColor = [211, 211, 211];
                });
            }
        },
        pageBreak: 'auto',
        rowPageBreak: 'avoid',
        margin: { left: 30, right: 25, top: 63, bottom: 40 }, // ⭐ same as Scheme
        theme: 'grid',
        headerStyles: {
            cellPadding: 3, lineWidth: 0.8, valign: 'top', fontStyle: 'bold',
            halign: 'center', fillColor: 'white', textColor: [0, 0, 0],
            fontSize: 7, lineColor: 'black',
        },
        bodyStyles: {
            columnWidth: 'wrap', textColor: [30, 30, 30], cellPadding: 4,
            fontSize: 7, lineColor: [6, 3, 1],
        },
        // ⭐ scaled down from the old landscape widths to fit portrait
        // content width (~540pt vs ~755pt) — same proportions kept
        columnStyles: {
            0: { valign: 'top', columnWidth: 55, halign: 'left' },  // Wastage No
            1: { columnWidth: 50, halign: 'left' },                 // Date
            2: { columnWidth: 90, halign: 'left' },                 // Party Name
            3: { columnWidth: 100, halign: 'left' },                // Item Name
            4: { columnWidth: 45, halign: 'left' },                 // Batch No
            5: { columnWidth: 40, halign: 'right' },                // Quantity
            6: { columnWidth: 35, halign: 'center' },               // Unit
            7: { columnWidth: 40, halign: 'right' },                // Rate
            8: { columnWidth: 45, halign: 'right' },                // Amount
            9: { columnWidth: 40, halign: 'right' },                // GST Amt
        },
        tableLineColor: 'black',
        startY: 63, // ⭐ same as Scheme
        didDrawPage: () => {
            pageBorder(doc);
            pageHeder(doc);
            reportHeder1(doc, dateRange);
        },
    };

    doc.autoTable(table.columns(), table.Rows(data), options);
};

// ⭐ identical to Scheme's pageFooter
export const pageFooter = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text('Print Date :' + String(currentDate_dmy) + ' Time ' + String(CurrentTime()), 30, 828);
        doc.text('Page ' + String(i) + ' of ' + String(pageCount), 500, 828);
    }
};